window.locals = {};

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

window.axios.defaults.baseURL = process.env.REACT_APP_API_URL;



var hj = {};

hj.json = function() {
    return {
        parse: function(a) {
            return (JSON.parse || JSON.decode)(a)
        },
        tryParse: function(a, b) {
            var c = !0,
                d;
            try {
                d = (JSON.parse || JSON.decode)(a);
                b && b(d)
            } catch (e) {
                c = !1
            }
            return c
        },
        stringify: function(a, b, c) {
            var d, e;
            if (void 0 !== a) return d = Array.prototype.toJSON, delete Array.prototype.toJSON, e = JSON.stringify || JSON.encode, a = ('"\u2028"' === e("\u2028") ? function(a, b, c) {
                    return e(a, b, c).replace(/\u2028|\u2029/g, function(a) {
                        return "\\u202" + ("\u2028" === a ? "8" : "9")
                    })
                } : e)(a, b, c), d && (Array.prototype.toJSON = d),
                a
        }
    }
}();

window.hj = hj;

window.onMessage = function(callback) {
    window.addEventListener ? window.addEventListener("message", callback, !1) : window.attachEvent("onmessage", callback);
}

var cookie = function() {
    return {
        getCookie: function(a) {
            return (a = RegExp("(?:^|; )" + a + "=([^;]*)").exec(document.cookie)) ? a[1] : void 0
        },

        setCookie: function(a, b, c) {
            var d = new Date;
            d.setDate(d.getDate() + c);
            document.cookie = a + "=" + b + "; path=/; expires=" + d.toUTCString()
        }
    }
}();

window.cookie = cookie;


window.uuidv4 = function() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0,
            v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
};


window.loadSdkAsynchronously = function(src, id) {
    return function(__dom, __tag, __id) {
        if (__dom.getElementById(__id)) return;
        var __fjs = __dom.getElementsByTagName(__tag)[0],
            __cjs = __dom.createElement(__tag);
        __cjs.id = __id;
        __cjs.src = src;
        __fjs.parentNode.insertBefore(__cjs, __fjs);
    }(document, 'script', id);
};


window.loadMessengerFrame = function(force=false) {
    window.axios.get('/get_current_user_chatbot').then(res => {
        if(res.data.status == 1) {
            var { user_id, user_token, chatbot_id} = res.data;
            var uid = (user_token+chatbot_id+user_id);
            var src = process.env.REACT_APP_SERVER_URL+"/server/vendor/messenger/web-live-messenger.js?u="+user_id +"&t=" +user_token +"&c="+chatbot_id;
            if(force && document.getElementById(uid)) {
                document.getElementById(uid).remove();
                document.getElementsByClassName("hansa-widget-area")[0].remove();
                window.loadSdkAsynchronously(src, uid);
            } else {
                window.loadSdkAsynchronously(src, uid);
            }
        }
    });
}



// WEBPACK FOOTER //
// ./src/bootstrap.js